export enum Region {
    OCEANIA = 'Oceania',
    AMERICA = 'America',
}
